import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(() => ({
  headerStyling: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: "10px"
  }
}));
